import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/progress-failed.png'
import _imports_1 from '@/assets/image/progress-success.png'
import _imports_2 from '@/assets/image/progress-warn.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-bbaaaedc")

_pushScopeId("data-v-bbaaaedc")
const _hoisted_1 = { class: "progress-outer" }
const _hoisted_2 = { class: "progress-status" }
const _hoisted_3 = {
  key: 0,
  class: "progress-text"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_0
}
const _hoisted_5 = {
  key: 2,
  src: _imports_1
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "progress",
    style: _ctx.status==='warn'?{width:_ctx.width+145+'px'}:{width: _ctx.width + 60 + 'px'}
  }, [
    _createVNode("div", {
      class: "progress-content",
      style: {width: _ctx.width + 'px'}
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: "progress-inner",
          style: { width: _ctx.percent + '%' }
        }, null, 4)
      ])
    ], 4),
    _createVNode("div", _hoisted_2, [
      (_ctx.percent != 100)
        ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.percent) + "%", 1))
        : (_ctx.status=='failed')
          ? (_openBlock(), _createBlock("img", _hoisted_4))
          : (_ctx.status=='success')
            ? (_openBlock(), _createBlock("img", _hoisted_5))
            : (_ctx.status=='warn')
              ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                  _renderSlot(_ctx.$slots, "warn"),
                  _hoisted_6
                ], 64))
              : _createCommentVNode("", true)
    ])
  ], 4))
})